import { render } from "./Incentives.vue?vue&type=template&id=6a4e845a&scoped=true&ts=true"
import script from "./Incentives.ts?vue&type=script&lang=ts&external"
export * from "./Incentives.ts?vue&type=script&lang=ts&external"

import "./Incentives.scss?vue&type=style&index=0&id=6a4e845a&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4e845a"]])

export default __exports__